import { h } from '../../../../src/shared/components/dom.js';

let modalEl = null;
let escListener = null;
let resolve = null;

export function openListNameModal({ title = 'New list', value = '', error = '' } = {}) {
  ensureModal();
  const titleEl = modalEl.querySelector('.lib-name-title');
  const input = modalEl.querySelector('.lib-name-input');
  const errorEl = modalEl.querySelector('.lib-name-error');
  titleEl.textContent = title;
  input.value = value;
  errorEl.textContent = error || '';
  show();
  input.focus();
  input.select();
  return new Promise((r) => { resolve = r; });
}

function ensureModal() {
  if (modalEl) return;
  const input = h('input', {
    type: 'text',
    class: 'lib-name-input',
    placeholder: 'List name…',
    'aria-label': 'List name',
    maxlength: '80',
  });
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') { e.preventDefault(); submit(); }
  });

  modalEl = h('div', {
    class: 'lib-name-modal hidden',
    role: 'dialog',
    'aria-modal': 'true',
    'aria-labelledby': 'lib-name-title',
  },
    h('div', { class: 'lib-name-content' },
      h('div', { class: 'lib-name-header' },
        h('span', { id: 'lib-name-title', class: 'lib-name-title' }, ''),
      ),
      h('div', { class: 'lib-name-body' },
        input,
        h('span', { class: 'lib-name-error' }, ''),
        h('div', { class: 'lib-name-actions' },
          h('button', { class: 'lib-btn lib-name-cancel', type: 'button', onclick: cancel }, 'Cancel'),
          h('button', { class: 'lib-btn lib-name-ok', type: 'button', onclick: submit }, 'OK'),
        ),
      ),
    ),
  );
  modalEl.addEventListener('click', (e) => {
    if (e.target === modalEl) cancel();
  });
  modalEl.querySelector('.lib-name-content').addEventListener('click', (e) => e.stopPropagation());
  document.body.appendChild(modalEl);
}

function show() {
  modalEl.classList.remove('hidden');
  escListener = (e) => { if (e.key === 'Escape') cancel(); };
  document.addEventListener('keydown', escListener);
}

function hide() {
  if (!modalEl) return;
  modalEl.classList.add('hidden');
  if (escListener) {
    document.removeEventListener('keydown', escListener);
    escListener = null;
  }
}

function submit() {
  const input = modalEl.querySelector('.lib-name-input');
  const name = input.value.trim();
  if (!name) return;
  hide();
  if (resolve) { resolve(name); resolve = null; }
}

function cancel() {
  hide();
  if (resolve) { resolve(null); resolve = null; }
}
